import { useTheme } from '@material-ui/core/styles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  getChatbotAnalyticsControlData,
  selectChatbotAnalyticsBusinessId,
} from '../store/slices/chatbotAnalyticsSlice';

export const ChatbotBusinesses = () => {
  const pageStyle = {
    fontFamily:
      'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    padding: '16px',
    backgroundColor: '#f8fafc',
    color: '#0f172a',
  };

  const headerStyle = {
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '12px',
  };

  const titleStyle = {
    fontSize: '22px',
    fontWeight: 700,
    margin: 0,
  };

  const kpisRowStyle = {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  };

  const kpiCardStyle = {
    backgroundColor: 'white',
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '12px 14px',
    minWidth: '180px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  };

  const kpiLabelStyle = {
    fontSize: '12px',
    color: '#64748b',
    marginBottom: '6px',
  };
  const kpiValueStyle = { fontSize: '20px', fontWeight: 700, color: '#0f172a' };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '12px',
    marginTop: '16px',
  };

  const cardStyle = {
    backgroundColor: 'white',
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '14px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  };

  // Allow the company name to wrap and not push the badge out
  const companyNameStyle = {
    fontSize: '16px',
    fontWeight: 700,
    margin: 0,
    flex: '1 1 auto',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  };

  const theme = useTheme();
  const history = useHistory();

  const dispatch = useDispatch();
  const chatbotAnalyticsControlData = useSelector(
    getChatbotAnalyticsControlData
  );

  const selectChatbotBusinessId = (businessId) => {
    history.push(`/chatbot-analytics/${businessId}`);
    dispatch(selectChatbotAnalyticsBusinessId(businessId));
  };

  return (
    <div>
      <div style={pageStyle}>
        {/* Header + KPIs */}
        <div style={headerStyle}>
          <h1 style={titleStyle}>Chatbot licences</h1>
        </div>

        {/* Companies grid */}
        <div style={gridStyle}>
          {chatbotAnalyticsControlData.chatbotLicencess.map((c) => {
            const active = c.deleted === 'FALSE';

            return (
              <div
                onClick={() => selectChatbotBusinessId(c.businessId)}
                key={c.businessId}
                style={{
                  ...cardStyle,
                  cursor: 'pointer',
                  border: active ? '2px solid #22c55e' : '1px solid #e2e8f0',
                  boxShadow: active
                    ? '0 0 8px rgba(34, 197, 94, 0.5)'
                    : '0 0 4px rgba(0,0,0,0.05)',
                  backgroundColor: active ? '#f0fdf4' : '#fff',
                  transition: 'all 0.2s ease',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap', // ✅ allow wrapping when name is long
                    gap: '6px 8px', // ✅ spacing when it wraps to a second line
                  }}
                >
                  <h3 style={companyNameStyle}>{c.businessName}</h3>
                  {active && (
                    <span
                      style={{
                        backgroundColor: '#22c55e',
                        color: 'white',
                        fontSize: '10px',
                        fontWeight: 600,
                        padding: '4px 8px',
                        borderRadius: '12px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Aktiivinen
                    </span>
                  )}
                </div>

                <div
                  style={{
                    height: '1px',
                    backgroundColor: '#e2e8f0',
                    margin: '8px 0',
                  }}
                />

                <div style={{ fontSize: '12px', color: '#64748b' }}>
                  y-tunnus:{' '}
                  <strong style={{ color: '#0f172a' }}>{c.businessId}</strong>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
